var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "article-list-item",
        "col-md-01",
        "tile-webinar",
        _vm.webinarTypeClass
      ]
    },
    [
      _c("h3", [_vm._v(_vm._s(_vm.result.WebinarTitle))]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _c("b", [_vm._v(_vm._s(_vm.webinarType) + " Webinar")]),
          _vm.webinarDate
            ? _c("span", [_vm._v(_vm._s(_vm.webinarDate))])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("p", {
          domProps: { innerHTML: _vm._s(_vm.result.WebinarDescription) }
        }),
        _vm._v(" "),
        _vm.result.WebinarURL
          ? _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: { href: _vm.result.WebinarURL }
              },
              [_vm._v("VIEW")]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5617b3fc", { render: render, staticRenderFns: staticRenderFns })
  }
}